import { Box, Button, Flex, Text, VStack } from "@chakra-ui/react"; //Vishy 2025-02-18 build warning "Input"not used, so removed
import React, { useEffect, useState } from "react";

import { Modal } from "antd"; //Vishy 2025-02-18 build warning "Select" not used, so removed

//// Icons

import { FaRegCalendarAlt } from "react-icons/fa"; //Vishy 2025-02-18 build warning "FaAngleLeft" not used, so removed
import { FiEdit } from "react-icons/fi";
import { useNavigate, useSearchParams } from "react-router-dom"; //Vishy 2025-02-18 build warning "useParams" not used, so removed
import Header from "../../Components/Common/Header";
import { SellerAPI } from "../../Apis/sellerAPI";
import { BuyerInterface } from "../../Interface/CommonInterface";
import { errorHandler } from "../../Utils/handler";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import Loader from "../../Components/Loader/Loader";
import NotesModal from "../../Components/Modals/NotesModal";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import CreateMeetModal from "../../Components/Modals/CreateMeetModal";

const Company = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({
    company: "",
    event: "",
  });

  const [searchParams] = useSearchParams();

  const [buyers, setBuyers] = useState<BuyerInterface[]>([]);
  const { success, error } = useToastWrapper();

    //Meet Modal
    const [meetModal, setMeetModal] = useState(false);
    const handleOpenMeetModal = () => setMeetModal(true);
    const handleCloseMeetModal = () => setMeetModal(false);
    const [meetResponder, setMeetResponder] = useState<any>();


  const [notesModal, setNotesModal] = useState(false);
  const handleOpenNotesModal = () => setNotesModal(true);
  const handleCloseNotesModal = () => setNotesModal(false);
  const [notesData, setNotesData] = useState<any>({
    forUser: "",
    eventId: "",
  });

  useEffect(() => {
    const obj = {
      company: "",
      event: "",
    };

    if (searchParams?.get("event")) {
      obj.event = searchParams?.get("event") || "";
    }

    if (searchParams?.get("company")) {
      obj.company = searchParams?.get("company") || "";
    }

    if (obj.event) {
      getBuyers(obj.event, obj?.company);
      setNotesData({
        ...notesData,
        eventId: obj.event,
      });
    }
    setDetails({ ...obj });
  }, [searchParams]);

  // Claude: updated to use query params instead of path param; eventId optional 18-02-2026
  const getBuyers = async (eventId: string | undefined, company: string) => {
    try {
      setLoading(true);

      const params: any = { companyName: company };
      if (eventId) params.eventId = eventId;

      const data = await SellerAPI.getBuyers(params);

      if (data.success) {
        setBuyers(data?.data?.data);
      }
    } catch (err: any) {
      const errMsg = errorHandler(err);
      error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      w={"100%"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      bg={"linear.100"}
      minH={"100dvh"}
      maxH={"100dvh"}
    >

       {/* Modal for Meet */}
       <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={meetModal}
        onOk={handleCloseMeetModal}
        onCancel={handleCloseMeetModal}
      >
        <CreateMeetModal responderId={meetResponder?.userId} eventId={details.event} company={meetResponder?.buyerPersonName} context="Inquiry" handleCloseModal={handleCloseMeetModal}/>
      </Modal>


      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={notesModal}
        onOk={handleCloseNotesModal}
        onCancel={handleCloseNotesModal}
      >
        <NotesModal
          eventId={notesData.eventId}
          forUser={notesData.forUser}
          handleCloseModal={handleCloseNotesModal}
        />
      </Modal>
      {loading && <Loader />}
      <VStack w={"100%"} px={"30px"}>
        <Box width={"100%"} mt={"30px"}>
          <Header backButton isWhite>
            {details?.company}
          </Header>
        </Box>

        <Box
          p={"20px"}
          w={"100%"}
          mt={"30px"}
          bg={"white"}
          border={"1px solid #E2E8F0"}
          borderRadius={"15px"}
          shadow={"sm"}
        >
          <Text fontWeight={600}>{details?.company}</Text>
        </Box>
      </VStack>

      <Box
        w={"100%"}
        bg={"white"}
        pt={"30px"}
        // marginTop={"auto"}
        h={"100%"}
        flex={1}
        marginTop={"30px"}
        minH={"100%"}
        overflowY={"auto"}
        overflowX={"hidden"}
        pb={"100px"}
        borderTopRadius={"40px"}
        px={"30px"}
      >
        <Text fontWeight={"semibold"} mb={2}>
          Employees
        </Text>
        <VStack w={"100%"} spacing={4}>
          {[...buyers].map((item, index) => (
            <Box
              key={"buyer_" + index}
              w={"100%"}
              // border={"1px solid #E2E8F0"}
              p={"15px 20px"}
              borderRadius={"10px"}
              shadow={"md"}
              display={"flex"}
              flexDirection={"column"}
              _hover={{
                shadow: "lg",
              }}
              position={"relative"}
            >
              <Text fontWeight={600}>{item?.buyerPersonName}</Text>
              <Flex>{/* <Text fontSize={"sm"}>12.03.2023 19:03</Text> */}</Flex>
              <Flex>
                <Text fontSize={"sm"}>{item?.buyerDesignation}</Text>
              </Flex>

              <Flex justifyContent={"space-between"} mt={5}>
                <Button colorScheme="transparent">
                  <span>
                    <FaRegCalendarAlt
                      onClick={() => {
                        handleOpenMeetModal()
                        setMeetResponder(item)
                      }}
                      size={22}
                      color="#000"
                    />
                  </span>
                </Button>
                <Button colorScheme="transparent">
                  <span>
                    <IoChatboxEllipsesOutline
                      onClick={() => {
                        navigate("/seller/chat?user=" + item?.userId+"&event="+ details.event+"&m="+item?._id, {
                          state: {
                            buyer: item,
                          },
                        });
                      }}
                      size={22}
                      color="#000"
                    />
                  </span>
                </Button>
                <Button colorScheme="transparent">
                  <span>
                    <FiEdit
                      onClick={() => {
                        handleOpenNotesModal();
                        setNotesData((prev: any) => ({
                          ...prev,
                          forUser: item?._id,
                        }));
                      }}
                      size={22}
                      color="#000"
                    />
                  </span>
                </Button>
              </Flex>
            </Box>
          ))}
        </VStack>
      </Box>
    </Box>
  );
};

export default Company;
